export default "__VITE_ASSET__Dzy9PWfX__"